// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"f5a933cd","316":"751c0895","508":"7a16a1a5","682":"deceb80a","980":"aa09b0ba"}[chunkId] + ".chunk.css";
};